export default __webpack_public_path__ + "static/media/moviesDetailsTop.18f73f68.jpeg";